import { Box, Paper } from "@mui/material";

export default function GlassCard({ children }) {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        maxWidth: 480,
        borderRadius: 3,
        p: 0.6,
        background: "linear-gradient(145deg, rgba(255,255,255,.28), rgba(255,255,255,.08))",
        boxShadow: "0 10px 30px rgba(0,0,0,.25), inset 0 1px 0 rgba(255,255,255,.15)",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          borderRadius: 2.5,
          p: { xs: 2.5, sm: 4 },
          textAlign: "center",
          color: "white",
          bgcolor: "rgba(255,255,255,0.035)",
          border: "1px solid rgba(255,255,255,0.25)",
          backdropFilter: "saturate(160%) blur(20px)",
          boxShadow: "inset 0 0 0 1px rgba(255,255,255,.05), 0 8px 22px rgba(0,0,0,.18)",
        }}
      >
        {children}
      </Paper>
    </Box>
  );
}
